import { IConfigsType } from '../../types'

const lfrConfig: IConfigsType = {
  'lfr-global-and-brand-layout-b61d68b9': {
    '/:brand/global-and-brand-layout': {
      groupFilter: {
        api: 'lfrBrandsGroupFilter',
        hide: true,
      },
      dateFilter: {
        types: [
          'week',
          'period',
          'quarter',
          'year',
          'trailing_364_days',
          'custom',
        ],
      },
      systemwideOverview: {
        type: 'list',
        api: 'lfrBusinessReviewKpis',
        title: 'Systemwide Overview',
        fieldWidth: '120px',
        fields: [
          {
            content: {
              key: 'grossSales',
            },
            bottom: 'Gross Sales',
          },
          {
            content: {
              key: 'grossSalesSssPercent',
              decimal: 1,
            },
            bottom: 'YOY%',
          },
          {
            content: {
              key: 'grossSalesBudgetVariance',
              decimal: 1,
            },
            bottom: 'Gross Sales Var',
          },
          {
            content: {
              key: 'revPsf',
            },
            bottom: 'Rev PSF',
          },
          {
            content: {
              key: 'ppa',
              decimal: 2,
            },
            bottom: 'Avg Spend',
          },
          {
            content: {
              key: 'covers',
            },
            bottom: 'Covers Actual',
          },
          {
            content: {
              key: 'hourlyLaborCostPercent',
              decimal: 1,
            },
            bottom: 'Hourly Labor',
          },
          {
            content: {
              key: 'hourlyLaborBudgetVariance',
              decimal: 1,
              color: '<%- value > 0 ? colors.Pomodoro : "" %>',
            },
            bottom: 'Hourly Labor Var',
          },
          {
            content: {
              key: 'cogsPercent',
              decimal: 1,
            },
            bottom: 'COGS Actual',
          },
          {
            content: {
              key: 'cogsBudgetVariance',
              decimal: 1,
              color: '<%- value > 0 ? colors.Pomodoro : "" %>',
            },
            bottom: 'COGS Var',
          },
          {
            content: {
              key: 'primeCostsPercent',
              decimal: 1,
            },
            bottom: 'Prime Cost',
          },
          {
            content: {
              key: 'primeCostsVariance',
              decimal: 1,
              color: '<%- value > 0 ? colors.Pomodoro : "" %>',
            },
            bottom: 'Prime Cost Var',
          },
          {
            content: {
              key: 'primeCostsPercentSss',
              decimal: 1,
              color: '<%- value > 0 ? colors.Pomodoro : "" %>',
            },
            bottom: 'Prime Cost YOY',
          },
          {
            content: {
              key: 'rcpPercent',
            },
            bottom: 'EBITDA %',
          },
        ],
      },
      breakdownByStore: {
        type: 'table',
        api: 'lfrListLocationGroupBusinessReview',
        title: 'Breakdown by Brand',
        pageSize: 20,
        defaultSortedField: 'grossSales',
        groupInfo: {
          width: '150px',
          groupBy: {
            width: '150px',
          },
        },
        columns: [
          {
            key: 'Gross Sales',
            title: 'Gross Sales',
            align: 'center',
            highlight: true,
            children: [
              {
                key: 'grossSales',
                title: '$',
                align: 'center',
                sortable: true,
              },
              {
                key: 'revPsf',
                title: 'Rev PSF',
                align: 'center',
                sortable: true,
              },
              {
                key: 'grossSalesBudgetVariance',
                title: 'Variance',
                align: 'center',
                sortable: true,
                decimal: 1,
              },
              {
                key: 'grossSalesSssPercent',
                title: 'YOY%',
                align: 'center',
                sortable: true,
                decimal: 1,
              },
            ],
          },
          {
            key: 'Comps',
            title: 'Comps',
            align: 'center',
            children: [
              {
                key: 'compsPercent',
                title: 'Comps',
                align: 'center',
                sortable: true,
              },
              {
                key: 'compsVariance',
                title: 'Variance',
                align: 'center',
                sortable: true,
              },
            ],
          },
          {
            key: 'Covers',
            title: 'Covers',
            align: 'center',
            highlight: true,
            children: [
              {
                key: 'covers',
                title: 'Covers',
                align: 'center',
                sortable: true,
              },
              {
                key: 'coversVariance',
                title: 'Variance',
                align: 'center',
                sortable: true,
              },
              {
                key: 'coversSss',
                title: 'YOY',
                align: 'center',
                sortable: true,
              },
            ],
          },
          {
            key: 'Spends',
            title: 'Spends',
            align: 'center',
            children: [
              {
                key: 'ppa',
                title: 'PPA$',
                align: 'center',
                sortable: true,
                decimal: 2,
              },
              {
                key: 'ppaVariance',
                title: 'Variance',
                align: 'center',
                sortable: true,
                decimal: 2,
              },
              {
                key: 'ppaSss',
                title: 'YOY',
                align: 'center',
                sortable: true,
                decimal: 2,
              },
            ],
          },
          {
            key: 'COGS',
            title: 'COGS',
            align: 'center',
            highlight: true,
            children: [
              {
                key: 'cogsPercent',
                title: '%',
                align: 'center',
                sortable: true,
                decimal: 1,
              },
              {
                key: 'cogsBudgetVariance',
                title: 'Variance',
                align: 'center',
                reverse: true,
                sortable: true,
                decimal: 1,
              },
            ],
          },
          {
            key: 'Hourly Labor',
            title: 'Hourly Labor',
            align: 'center',
            children: [
              {
                key: 'hourlyLaborCostPercent',
                title: '%',
                align: 'center',
                sortable: true,
                decimal: 1,
              },
              {
                key: 'hourlyLaborBudgetVariance',
                title: 'Variance',
                align: 'center',
                sortable: true,
                decimal: 1,
                reverse: true,
              },
            ],
          },
          {
            key: 'Prime Costs',
            title: 'Prime Costs',
            align: 'center',
            highlight: true,
            children: [
              {
                key: 'primeCostsPercent',
                title: '%',
                align: 'center',
                sortable: true,
                decimal: 1,
              },
              {
                key: 'primeCostsVariance',
                title: 'Variance',
                align: 'center',
                sortable: true,
                decimal: 1,
                reverse: true,
              },
              {
                key: 'primeCostsPercentSss',
                title: 'YOY',
                align: 'center',
                sortable: true,
                decimal: 1,
                reverse: true,
              },
            ],
          },
          {
            key: 'EBITDA',
            title: 'EBITDA',
            align: 'center',
            children: [
              {
                key: 'rcp',
                title: '$',
                align: 'center',
                sortable: true,
              },
              {
                key: 'rcpPercent',
                title: '%',
                align: 'center',
                sortable: true,
              },
              {
                key: 'rcpBudgetVariance',
                title: 'Variance',
                align: 'center',
                sortable: true,
              },
            ],
          },
        ],
      },
    },
  },
}

export default lfrConfig
